function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgLockFilled = function SvgLockFilled(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Lock' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M24 47C11.2974508 47 1 36.7025492 1 24S11.2974508 1 24 1s23 10.2974508 23 23-10.2974508 23-23 23z",
    fill: props.fill
  }), React.createElement("path", {
    d: "M16.0219427 18C16.2794256 12.2802358 18.8102572 9 24 9c5.1897428 0 7.7205744 3.2802358 7.9780573 9H35v18H13V18h3.0219427zm2.0007288 0h11.954657C29.7567576 13.3144463 27.9163065 11 24 11c-3.9163065 0-5.7567576 2.3144463-5.9773285 7zM24 30.2222222c.3837778 0 .7162222-.2603333.8011667-.627l.9857222-3.2883889c.2609444-1.1250555-.6111111-2.1957222-1.7868889-2.1957222-1.1757778 0-2.0478333 1.0706667-1.7868889 2.1957222l.9857222 3.2883889c.0849445.3666667.4173889.627.8011667.627z",
    fill: "#FFF",
    fillRule: "nonzero"
  }));
};

SvgLockFilled = pure(SvgLockFilled);
SvgLockFilled.displayName = 'SvgLockFilled';
export default SvgLockFilled;